import Reveal from "./Reveal";
import { IMAGES, SITE } from "@/constants/site";

const TILES = [
  { src: IMAGES.aerialRiver, alt: "Düzbağ Life akarsu ve dağ manzarası" },
  { src: IMAGES.sauna, alt: "Düzbağ Life sauna" },
  { src: IMAGES.restaurant, alt: "Düzbağ Life restaurant" },
  { src: IMAGES.night, alt: "Düzbağ Life gece görünümü" },
  { src: IMAGES.pool, alt: "Düzbağ Life havuz" },
  { src: IMAGES.bedroom, alt: "Düzbağ Life yatak odası" },
];

export default function InstagramSection() {
  return (
    <section className="w-full bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-20 md:py-28">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="text-secondary-600 text-xs tracking-[0.3em] uppercase">
            Instagram
          </span>
          <h2 className="mt-5 font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-[1.15] font-medium">
            DÜZBAĞ LIFE'I TAKİP EDİN
          </h2>
          <a
            href={SITE.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 inline-flex items-center gap-2 text-secondary-600 hover:text-secondary-700 font-medium whitespace-nowrap cursor-pointer transition-colors"
          >
            <i className="ri-instagram-line text-lg" />
            {SITE.instagramHandle}
          </a>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
          {TILES.map((tile, index) => (
            <Reveal key={tile.src} delay={(index % 3) * 80}>
              <a
                href={SITE.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="group block relative w-full aspect-square rounded-lg overflow-hidden cursor-pointer"
              >
                <img
                  src={tile.src}
                  alt={tile.alt}
                  title="Düzbağ Life instagram"
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute inset-0 bg-foreground-950/0 group-hover:bg-foreground-950/35 transition-colors flex items-center justify-center">
                  <i className="ri-instagram-line text-background-50 text-3xl opacity-0 group-hover:opacity-100 transition-opacity" />
                </span>
              </a>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120} className="mt-10 text-center">
          <a
            href={SITE.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 border border-foreground-300 text-foreground-800 font-semibold px-7 py-3.5 rounded-md whitespace-nowrap transition-colors hover:bg-background-100 cursor-pointer"
          >
            <i className="ri-instagram-line text-lg" />
            Instagram'da İncele
          </a>
        </Reveal>
      </div>
    </section>
  );
}